import { useMemo } from 'react'
import { useSuspenseQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

export function useBanners() {
  const { data } = useSuspenseQuery(AdminAPI.banner.GET_ALL)

  return useMemo(() => {
    return data.getAllBanner
      ?.map(ban => getFragment(SharedAPI.banner.BANNER_FRAGMENT, ban))
      .toSorted((banA, banB) => banA.name.localeCompare(banB.name))
  }, [data])
}
